<template>
  <div>
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/market/marketBanner.jpg);height:713px"
      >
        <div class="content">
          <div class="banner">
            <p class="p1">才聚云端</p>
            <p class="p2">——让梦想不再遥远!</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 切换 -->
    <div style="overflow:hidden;">
      <div class="content">
        <div class="title">
          <div
            class="enterprise"
            @click="enterprieColor()"
            :class="{enterpriseStyle:enterprise === 1 }"
          >
            <img
              src="../../public/images/market/makerEnterprise2-2.png"
              style="width:100px;height:100px;margin-top:40px"
              class="img1"
            />
            <img
              src="../../public/images/market/marketEnterprise2.png"
              style="width:100px;height:100px;margin-top:40px"
              class="img2"
            />
            <p>企业发布</p>
          </div>
          <div class="maker" @click="makerColor()" :class="{makerStyle:enterprise === 2}">
            <p>
              <img
                src="../../public/images/market/marketMaker1.png"
                style="width:100px;height:100px;margin-top:40px"
                class="img1"
              />
              <img
                src="../../public/images/market/marketMaker1-1.png"
                style="width:100px;height:100px;margin-top:40px"
                class="img2"
              />
              创客发布
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务内容 -->
    <div style="overflow:hidden;" class="serve">
      <div class="content serve">
        <div class="serve-title">
          <p>
            <span>热门推荐</span>
            <span>最新发布</span>
            <span>浏览最多</span>
          </p>
        </div>
        <div class="serve-content" v-for="(item,index) in serviceList" :key="index">
          <div class="text" @click="toServiceInfo(item)">
            <div class="text1">
              <p>{{item.serviceName}}</p>
              <p>{{item.serviceCompany}}</p>
            </div>
            <div class="text2">
              <p>{{item.serviceArea}}</p>
              <p>有效期:{{item.serviceDate}}</p>
            </div>
          </div>
          <div class="info" v-if="enterprise === 1">
            <span>电话咨询</span>
          </div>
          <div class="info" v-if="enterprise === 2">
            <span>联系电话</span>
          </div>
        </div>
        <div class="service-footer">
          <p>查看更多</p>
        </div>
      </div>
    </div>
    <div style="overflow:hidden;">
      <img src="../../public/images/footer.jpg" />
    </div>
    <Nav></Nav>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/nav";
import Footer from "../components/footer";
export default {
  name: "education",
  data () {
    return {
      serviceList: [],
      enterpriseList: [
        {
          serviceName: "设计服务",
          serviceCompany: "***设计公司",
          workArea: "西安 | 本科",
          serviceDate: "2020-09-12",
          serviceType: "文化创意服务",
          registered: "一百万元",
          serviceArea: "西安市",
          setup: "2012-09-12",
          start: "1",
          proficiency: "熟练",
          education: "大学",
          age: "23岁~40岁",
          sex: "无",
          describe: "是指把计划、规划、设想通过视觉、文字等形式传递出来的业务活动。包括工业设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、工程设计、广告设计、创意策划、文印晒图等。	"
        },
        {
          serviceName: "软件服务",
          serviceCompany: "***软件公司",
          workArea: "西安 | 本科",
          serviceDate: "2020-01-13",
          serviceType: "文化创意服务",
          registered: "一百万元",
          serviceArea: "西安市",
          setup: "2012-09-12",
          start: "1",
          proficiency: "熟练",
          education: "大学",
          age: "23岁~40岁",
          sex: "无",
          describe: "是指把计划、规划、设想通过视觉、文字等形式传递出来的业务活动。包括工业设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、工程设计、广告设计、创意策划、文印晒图等。	"
        },
        {
          serviceName: "信息系统服务服务",
          serviceCompany: "保利***有限公司",
          workArea: "西安 | 本科",
          serviceDate: "2020-09-12",
          serviceType: "文化创意服务",
          registered: "一百万元",
          serviceArea: "西安市",
          setup: "2012-09-12",
          start: "1",
          proficiency: "熟练",
          education: "大学",
          age: "23岁~40岁",
          sex: "无",
          describe: "是指把计划、规划、设想通过视觉、文字等形式传递出来的业务活动。包括工业设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、工程设计、广告设计、创意策划、文印晒图等。	"
        },
        {
          serviceName: "业务流程管理服务",
          serviceCompany: "嘉禾***科技有限公司",
          workArea: "咸阳 | 博士",
          serviceDate: "2020-11-12",
          serviceType: "文化创意服务",
          registered: "一百万元",
          serviceArea: "西安市",
          setup: "2012-09-12",
          start: "1",
          proficiency: "熟练",
          education: "大学",
          age: "23岁~40岁",
          sex: "无",
          describe: "是指把计划、规划、设想通过视觉、文字等形式传递出来的业务活动。包括工业设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、工程设计、广告设计、创意策划、文印晒图等。	"
        },
        {
          serviceName: "会议展览服务服务",
          serviceCompany: "嘉禾***科技有限公司",
          workArea: "临潼 | 本科",
          serviceDate: "2021-01-12",
          serviceType: "文化创意服务",
          registered: "一百万元",
          serviceArea: "西安市",
          setup: "2012-09-12",
          start: "1",
          proficiency: "熟练",
          education: "大学",
          age: "23岁~40岁",
          sex: "无",
          describe: "是指把计划、规划、设想通过视觉、文字等形式传递出来的业务活动。包括工业设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、工程设计、广告设计、创意策划、文印晒图等。	"
        },
        {
          serviceName: "其他现代服务",
          serviceCompany: "安利***科技有限公司",
          workArea: "汉中 | 本科",
          serviceDate: "2021-03-12",
          serviceType: "文化创意服务",
          registered: "一百万元",
          serviceArea: "西安市",
          setup: "2012-09-12",
          start: "1",
          proficiency: "熟练",
          education: "大学",
          age: "23岁~40岁",
          sex: "无",
          describe: "是指把计划、规划、设想通过视觉、文字等形式传递出来的业务活动。包括工业设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、工程设计、广告设计、创意策划、文印晒图等。	"
        },
        {
          serviceName: "技术研发服务",
          serviceCompany: "安利***科技有限公司",
          workArea: "汉中 | 本科",
          serviceDate: "2021-03-12",
          serviceType: "文化创意服务",
          registered: "一百万元",
          serviceArea: "西安市",
          setup: "2012-09-12",
          start: "1",
          proficiency: "熟练",
          education: "大学",
          age: "23岁~40岁",
          sex: "无",
          describe: "是指把计划、规划、设想通过视觉、文字等形式传递出来的业务活动。包括工业设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、工程设计、广告设计、创意策划、文印晒图等。	"
        },
      ],
      makerList: [
        {
          serviceName: "JAVA技术",
          serviceCompany: "李*鑫",
          serviceArea: "西安 | 6年",
          serviceDate: "发布时间：2020-10-12",
          experience: "8年",
          skillName: "javascript、xml、ext、dwr",
          education: "大学",
          proficiency: "精通",
          explain: "熟练myeclipse 平台，熟练在weblogic或tomcat服务下编程，对于struct 、hibernate、spring 技术框架应用精通、熟悉javascript、xml、ext、dwr、jquery、jxl、commons-fileupload、freemarker 等技术，数据库主要使用的是oracle，对于C++、net 等语言也熟悉，有规范的开发、文档写作能力。"
        },
        {
          serviceName: "WEB",
          serviceCompany: "王*",
          serviceArea: "咸阳 | 1年",
          serviceDate: "发布时间：2020-04-13",
          experience: "8年",
          skillName: "javascript、xml、ext、dwr",
          education: "硕士",
          proficiency: "精通",
          explain: "熟练myeclipse 平台，熟练在weblogic或tomcat服务下编程，对于struct 、hibernate、spring 技术框架应用精通、熟悉javascript、xml、ext、dwr、jquery、jxl、commons-fileupload、freemarker 等技术，数据库主要使用的是oracle，对于C++、net 等语言也熟悉，有规范的开发、文档写作能力。"
        },
        {
          serviceName: "财务会计",
          serviceCompany: "李**紫",
          serviceArea: "西安 | 2年",
          serviceDate: "发布时间：2020-09-12",
          experience: "8年",
          skillName: "javascript、xml、ext、dwr",
          education: "本科",
          proficiency: "精通",
          explain: "熟练myeclipse 平台，熟练在weblogic或tomcat服务下编程，对于struct 、hibernate、spring 技术框架应用精通、熟悉javascript、xml、ext、dwr、jquery、jxl、commons-fileupload、freemarker 等技术，数据库主要使用的是oracle，对于C++、net 等语言也熟悉，有规范的开发、文档写作能力。"
        },
        {
          serviceName: "水电检测",
          serviceCompany: "张**浩",
          serviceArea: "临潼 | 3年",
          serviceDate: "发布时间：2020-05-12",
          experience: "8年",
          skillName: "javascript、xml、ext、dwr",
          education: "本科",
          proficiency: "精通",
          explain: "熟练myeclipse 平台，熟练在weblogic或tomcat服务下编程，对于struct 、hibernate、spring 技术框架应用精通、熟悉javascript、xml、ext、dwr、jquery、jxl、commons-fileupload、freemarker 等技术，数据库主要使用的是oracle，对于C++、net 等语言也熟悉，有规范的开发、文档写作能力。"
        },
        {
          serviceName: "图纸设计",
          serviceCompany: "王**嘉",
          serviceArea: "临潼 | 3年",
          serviceDate: "发布时间：2020-04-12",
          experience: "8年",
          skillName: "javascript、xml、ext、dwr",
          education: "博士",
          proficiency: "精通",
          explain: "熟练myeclipse 平台，熟练在weblogic或tomcat服务下编程，对于struct 、hibernate、spring 技术框架应用精通、熟悉javascript、xml、ext、dwr、jquery、jxl、commons-fileupload、freemarker 等技术，数据库主要使用的是oracle，对于C++、net 等语言也熟悉，有规范的开发、文档写作能力。"
        },
        {
          serviceName: "家政服务",
          serviceCompany: "王**豪",
          serviceArea: "临潼 | 3年",
          serviceDate: "发布时间：2020-04-12",
          experience: "8年",
          skillName: "javascript、xml、ext、dwr",
          education: "博士",
          proficiency: "精通",
          explain: "熟练myeclipse 平台，熟练在weblogic或tomcat服务下编程，对于struct 、hibernate、spring 技术框架应用精通、熟悉javascript、xml、ext、dwr、jquery、jxl、commons-fileupload、freemarker 等技术，数据库主要使用的是oracle，对于C++、net 等语言也熟悉，有规范的开发、文档写作能力。"
        },
        {
          serviceName: "软件开发",
          serviceCompany: "李*",
          serviceArea: "临潼 | 1年",
          serviceDate: "发布时间：2020-05-22",
          experience: "8年",
          skillName: "javascript、xml、ext、dwr",
          education: "本科",
          proficiency: "精通",
          explain: "熟练myeclipse 平台，熟练在weblogic或tomcat服务下编程，对于struct 、hibernate、spring 技术框架应用精通、熟悉javascript、xml、ext、dwr、jquery、jxl、commons-fileupload、freemarker 等技术，数据库主要使用的是oracle，对于C++、net 等语言也熟悉，有规范的开发、文档写作能力。"
        },
      ],
      enterprise: 1,
      maker: false
    }
  },
  created () {
    this.serviceList = this.enterpriseList
    const queryEnterprise = this.$route.query.data * 1
    if (queryEnterprise) {
      if (queryEnterprise === 1) {
        this.enterprieColor()
      }
      if (queryEnterprise === 2) {
        this.makerColor()
      }
    }
  },
  methods: {
    enterprieColor () {
      this.serviceList = this.enterpriseList
      this.enterprise = 1
    },
    makerColor () {
      this.serviceList = this.makerList
      this.enterprise = 2
    },
    toServiceInfo (data) {
      if (this.enterprise === 1) {
        this.$router.push({
          path: "/enterprise_info",
          query: { data: JSON.stringify(data) }
        })
      }
      if (this.enterprise === 2) {
        this.$router.push({
          path: "/maker_info",
          query: { data: JSON.stringify(data) }
        })
      }

    }
  },
  components: {
    Nav,
    Footer,
  },
};
</script>

<style scoped>
/* banner */
.banner {
  height: 100vh;
}
.banner .p1 {
  width: 100%;
  text-align: left;
  font-family: "MicrosoftYaHei";
  font-size: 76px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 100px;
  letter-spacing: 0px;
  color: #ffffff;
  padding-top: 290px;
  padding-left: 136px;
}
.banner .p2 {
  width: 100%;
  font-family: "MicrosoftYaHei";
  font-size: 76px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 100px;
  letter-spacing: 0px;
  color: #ffffff;
  margin-top: 60px;
  text-align: right;
}
/* 切换 */
.title {
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.title .enterprise {
  height: 160px;
  width: 500px;
  background: #ffff;
  color: black;
  display: flex;
  padding-left: 80px;
  margin-right: 10px;
  border: none;
  border-bottom: solid 4px #bfbfbf;
}
.title .maker {
  height: 160px;
  width: 500px;
  color: black;
  border-bottom: solid 4px #bfbfbf;
  display: flex;
  padding-left: 80px;
}
.enterpriseStyle {
  background: #64cdff !important;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.23);
  border-bottom: none !important;
}
.enterprise .img1 {
  display: none;
}
.enterprise .img2 {
  display: block;
}
.maker .img1 {
  display: none;
}

.enterpriseStyle .img2 {
  display: none;
}
.enterpriseStyle .img1 {
  display: block;
}
.enterpriseStyle p {
  color: #fff !important;
}
.makerStyle {
  background: #64cdff;
  border: none !important;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.23) !important;
}
.makerStyle p {
  color: #ffffff;
}
.title .enterprise p,
.maker p {
  text-align: center;
  line-height: 160px;
  letter-spacing: 6px;
  font-size: 40px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  display: flex;
}
/* 服务内容 */
.serve {
  background: #f1f3f8;
}
.serve-title {
  padding: 10px 0px;
  background: #ffffff;
  margin-top: 20px;
}
.serve-title p {
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.serve-title p span {
  display: inline-block;
  padding: 5px;
  border: solid 1px #2b77fe;
  margin: 0px 10px;
  cursor: pointer;
}
.serve-content {
  margin-top: 20px;
  background: #ffffff;
}
.serve-content,
.text2,
.text1 {
  display: flex;
}
.serve-content .text {
  flex-grow: 1;
  padding: 20px 30px;
  cursor: pointer;
}
.serve-content .text1,
.text2 {
  display: flex;
  justify-content: space-around;
}
.serve-content .text1 p:nth-child(1) {
  font-size: 25px;
  width: 100%;
  font-weight: 600;
}
.serve-content .text1 p:nth-child(2) {
  font-size: 16px;
  color: #cccccc;
  width: 100%;
}
.serve-content .text2 {
  margin-top: 6px;
}
.serve-content .text2 p {
  color: #767676;
  font-size: 16px;
  width: 100%;
  letter-spacing: 3px;
}
.serve-content .info {
  /* width: 120px; */
  padding: 0 10px;
  height: 100px;
  background-color: #64cdff;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.23);
  color: #ffffff;
}
.serve-content .info span {
  font-size: 24px;
  letter-spacing: 5px;
  display: inline-block;
  width: 100%;
  text-align: center;
  line-height: 100px;
  cursor: pointer;
}
/* 检查更多 */
.service-footer {
  height: 50px;
  margin-top: 20px;
  background: #ffffff;
  margin-bottom: 50px;
}
.service-footer p {
  text-align: center;
  line-height: 60px;
  cursor: pointer;
}
</style>